import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Warning = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        d="M7.8 15.6C12.1078 15.6 15.6 12.1078 15.6 7.8C15.6 3.49218 12.1078 0 7.8 0C3.49218 0 0 3.49218 0 7.8C0 12.1078 3.49218 15.6 7.8 15.6Z"
        fill="#D43434"
      />
      <path
        d="M6.88207 10.7906C6.88207 11.3244 7.31094 11.7246 7.88281 11.7246C8.45467 11.7246 8.88354 11.3244 8.88354 10.7906C8.88354 10.2569 8.45467 9.85659 7.88281 9.85659C7.31094 9.78989 6.88207 10.2569 6.88207 10.7906Z"
        fill="white"
      />
      <path
        d="M6.95349 8.32212L6.45309 4.98631C6.31015 4.1857 7.02496 3.45184 7.8827 3.45184C8.7405 3.45184 9.4553 4.1857 9.31231 4.98631L8.81192 8.32212C8.74045 8.7224 8.38305 9.05597 7.88265 9.05597C7.38236 9.12273 7.02496 8.78915 6.95349 8.32212Z"
        fill="white"
      />
    </SvgIcon>
  ))
);

export default Warning;
